import React, { Component } from 'react';
import {
  Form,
  Grid,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';

import Utils from '../Utils.js';

let camera_positions = [
  { text: 'No Camera',    value: 'none', },
  { text: 'Bottom Right', value: 'bottom_right', },
  { text: 'Bottom Left',  value: 'bottom_left', },
  { text: 'Top Left',     value: 'top_left', },
  { text: 'Top Right',    value: 'top_right', },
];

let wording_patterns = [
  { text: 'Twitch',   value: 'twitch', },
  { text: 'YouTube',  value: 'youtube', },
  { text: 'Custom',   value: 'custom', },
];

class Options extends Component {
  constructor(props) {
    super(props);

    this.state = {
      capacities: this.props.capacities,
      last_follow: true,
      last_subscribe: true,
      last_donation: true,
      last_follow_text: 'Last Follow',
      last_subscribe_text: 'Last Subscribe',
      last_donation_text: 'Last Donation',
      camera_position: 'bottom_right',
      wording_pattern: 'twitch',
      banner_middle_text: 'IS CURRENTLY',
      banner_big_text: 'Offline',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ capacities: nextProps.capacities, });
  }

  onCameraPosition = (event, data) => {
    this.props.onCameraPosition(data.value);
    this.setState({ camera_position: data.value });
  }

  onWordingPattern = (event, data) => {
    let donation = 'Last Donation';
    let subscribe = 'Last Subscribe';
    let follow = 'Last Follow';
    switch (data.value) {
      default:
      case 'twitch':
        // use default var values
        break;
      case 'youtube':
        donation = 'Last Donation';
        subscribe = 'Last Membership';
        follow = 'Last SuperChat';
        break;
    }

    this.props.onLastFollowText(follow);
    this.props.onLastSubscribeText(subscribe);
    this.props.onLastDonationText(donation);

    this.setState({ last_follow_text: follow });
    this.setState({ last_subscribe_text: subscribe });
    this.setState({ last_donation_text: donation });
    this.setState({ wording_pattern: data.value });
  }

  toggleLastFollow = () => {
    this.props.onLastFollow(!this.state.last_follow);
    this.setState({ last_follow: !this.state.last_follow, });
  }

  toggleLastSubscribe = () => {
    this.props.onLastSubscribe(!this.state.last_subscribe);
    this.setState({ last_subscribe: !this.state.last_subscribe, });
  }

  toggleLastDonation = () => {
    this.props.onLastDonation(!this.state.last_donation);
    this.setState({ last_donation: !this.state.last_donation, });
  }

  onBannerMiddleText = (event, data) => {
    this.props.onBannerMiddleText(data.value);
    this.setState({ banner_middle_text: data.value, });
  }

  onBannerBigText = (event, data) => {
    this.props.onBannerBigText(data.value);
    this.setState({ banner_big_text: data.value, });
  }

  onLastFollow = (event, data) => {
    this.props.onLastFollowText(data.value);
    this.setState({ last_follow_text: data.value, });
  }

  onLastSubscribe = (event, data) => {
    this.props.onLastSubscribeText(data.value);
    this.setState({ last_subscribe_text: data.value, });
  }

  onLastDonation = (event, data) => {
    this.props.onLastDonationText(data.value);
    this.setState({ last_donation_text: data.value, });
  }

  render() {
    if (Utils.hasNoneCapacities(this.state.capacities, ['camera_pos', 'last_subscribe', 'last_follow', 'last_donation', 'banner_middle_text', 'banner_big_text'])) {
      return null;
    }

    return (
      <Grid columns={1} stackable>
        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign='left'>
              <Icon name='settings'/>
              <Header.Content>Options</Header.Content>
              <Header.Subheader>We've nearly finished.</Header.Subheader>
            </Header>
          </Segment>
        </Grid.Column>

        {Utils.hasCapacity(this.state.capacities, 'banner_middle_text') &&
        <Grid.Row columns={2}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
            <strong>Junction text</strong>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input size='huge' value={this.state.banner_middle_text} onChange={this.onBannerMiddleText} placeholder="IS CURRENTLY" />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}

        {Utils.hasCapacity(this.state.capacities, 'banner_big_text') &&
        <Grid.Row columns={2}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
            <strong>Big text</strong>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input size='huge' value={this.state.banner_big_text} onChange={this.onBannerBigText} placeholder="Offline" />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}

        {Utils.hasCapacity(this.state.capacities, 'camera_pos') &&
        <Grid.Row columns={2}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={4}>
            <strong>Camera position</strong>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Dropdown onChange={this.onCameraPosition} value={this.state.camera_position} fluid selection options={camera_positions} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}

        {Utils.hasCapacity(this.state.capacities, 'last_follow') &&
        <Grid.Row columns={2}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={4}>
            <strong>Stream Last Interactions</strong>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Dropdown onChange={this.onWordingPattern} value={this.state.wording_pattern} fluid selection options={wording_patterns} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}
        {Utils.hasCapacity(this.state.capacities, 'last_follow') &&
        <Grid.Row columns={6}>
          <Grid.Column verticalAlign='middle' textAlign='right'>
            {Utils.hasCapacity(this.state.capacities, 'last_subscribe') &&
            <Form.Checkbox defaultChecked={true} onChange={this.toggleLastSubscribe} toggle />}
          </Grid.Column>
          <Grid.Column textAlign='left'>
            {this.state.wording_pattern !== 'custom' && <span>{this.state.last_subscribe_text}</span>}
            {this.state.wording_pattern === 'custom' && <Form.Input disabled={!this.state.last_subscribe} size='small' value={this.state.last_subscribe_text} onChange={this.onLastSubscribe} ></Form.Input>}
          </Grid.Column>

          <Grid.Column verticalAlign='middle' textAlign='right'>
            {Utils.hasCapacity(this.state.capacities, 'last_follow') &&
            <Form.Checkbox defaultChecked={true} onChange={this.toggleLastFollow} toggle />}
          </Grid.Column>
          <Grid.Column textAlign='left'>
            {this.state.wording_pattern !== 'custom' && <span>{this.state.last_follow_text}</span>}
            {this.state.wording_pattern === 'custom' && <Form.Input disabled={!this.state.last_follow} size='small' value={this.state.last_follow_text} onChange={this.onLastFollow} ></Form.Input>}
          </Grid.Column>

          <Grid.Column verticalAlign='middle' textAlign='right'>
            {Utils.hasCapacity(this.state.capacities, 'last_donation') &&
            <Form.Checkbox defaultChecked={true} onChange={this.toggleLastDonation} toggle />}
          </Grid.Column>
          <Grid.Column textAlign='left'>
            {this.state.wording_pattern !== 'custom' && <span>{this.state.last_donation_text}</span>}
            {this.state.wording_pattern === 'custom' && <Form.Input disabled={!this.state.last_donation} size='small' value={this.state.last_donation_text} onChange={this.onLastDonation} ></Form.Input>}
          </Grid.Column>
        </Grid.Row>}
      </Grid>
    );
  }
}

export default Options;



// WEBPACK FOOTER //
// ./src/tool/Options.js